import { AbsoluteColor, ColorShade } from '../palette/palette.types'

export const lightAbsoluteColors = {
  [AbsoluteColor.min]: '#FFFFFF',
  [AbsoluteColor.max]: '#000000',
}

export const darkAbsoluteColors = {
  [AbsoluteColor.min]: '#000000',
  [AbsoluteColor.max]: '#FFFFFF',
}

export const lightStatusPalettes = {
  danger: {
    [ColorShade.foreground]: '#FFFFFF',
    [ColorShade.softer]: '#F09A9A',
    [ColorShade.soft]: '#EB7878',
    [ColorShade.semiSoft]: '#E65757',
    [ColorShade.color]: '#E13535',
    [ColorShade.semiStrong]: '#C81E1E',
  },
  warning: {
    [ColorShade.foreground]: '#FFFFFF',
    [ColorShade.softer]: '#FFE6AD',
    [ColorShade.soft]: '#FFDA84',
    [ColorShade.semiSoft]: '#FFC131',
    [ColorShade.color]: '#FFB508',
    [ColorShade.semiStrong]: '#B35410',
  },
  success: {
    [ColorShade.foreground]: '#FFFFFF',
    [ColorShade.softer]: '#B0EAC5',
    [ColorShade.soft]: '#62D68C',
    [ColorShade.semiSoft]: '#3ACB6F',
    [ColorShade.color]: '#13C152',
    [ColorShade.semiStrong]: '#139744',
  },
  info: {
    [ColorShade.foreground]: '#FFFFFF',
    [ColorShade.softer]: '#B3E5FC',
    [ColorShade.soft]: '#4FC3F7',
    [ColorShade.semiSoft]: '#29B6F6',
    [ColorShade.color]: '#03A9F4',
    [ColorShade.semiStrong]: '#039BE5',
  },
}

export const darkStatusPalettes = {
  danger: {
    [ColorShade.foreground]: '#FFFFFF',
    [ColorShade.softer]: '#771D1D',
    [ColorShade.soft]: '#9A1C1D',
    [ColorShade.semiSoft]: '#C81E1E',
    [ColorShade.color]: '#E13535',
    [ColorShade.semiStrong]: '#F05251',
  },
  warning: {
    [ColorShade.foreground]: '#FFFFFF',
    [ColorShade.softer]: '#8C3F11',
    [ColorShade.soft]: '#B35410',
    [ColorShade.semiSoft]: '#E27E0C',
    [ColorShade.color]: '#FFB508',
    [ColorShade.semiStrong]: '#FFD43A',
  },
  success: {
    [ColorShade.foreground]: '#FFFFFF',
    [ColorShade.softer]: '#13512A',
    [ColorShade.soft]: '#1B7F41',
    [ColorShade.semiSoft]: '#139744',
    [ColorShade.color]: '#13C152',
    [ColorShade.semiStrong]: '#43DF7A',
  },
  info: {
    [ColorShade.foreground]: '#FFFFFF',
    [ColorShade.softer]: '#0277BD',
    [ColorShade.soft]: '#0288D1',
    [ColorShade.semiSoft]: '#039BE5',
    [ColorShade.color]: '#03A9F4',
    [ColorShade.semiStrong]: '#29B6F6',
  },
}
